import { useContext, useMemo } from "react";

import { AppContext } from "@vahak/core/dist/app-context";
import { CitySearchResultWithCateg, PlaceSearchResult } from "@vahak/core/dist/custom-types/location-search";

/** Read resolved user location from app context — avoids duplicate location API calls. */
export function useAppUserPlaceInfo() {
    const { globalData } = useContext(AppContext);
    return globalData?.userPlaceInfo as PlaceSearchResult | undefined;
}

export function useAppUserCityLocation(): CitySearchResultWithCateg | undefined {
    const userPlaceInfo = useAppUserPlaceInfo();

    return useMemo(() => {
        if (!userPlaceInfo?.place_id) {
            return undefined;
        }

        return {
            place_id: userPlaceInfo.place_id,
            city: userPlaceInfo.city,
            name: userPlaceInfo.description ?? userPlaceInfo.city,
            state: userPlaceInfo.state
        };
    }, [userPlaceInfo]);
}
